import { create } from "zustand";

interface NotionState {
  searchQuery: string;
  staleIds: Set<string>;
  setSearchQuery: (q: string) => void;
  setStaleIds: (ids: Set<string>) => void;
}

export const useNotionStore = create<NotionState>((set) => ({
  searchQuery: "",
  staleIds: new Set(),
  setSearchQuery: (searchQuery) => set({ searchQuery }),
  setStaleIds: (staleIds) => set({ staleIds }),
}));
